// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const electrike: PokeData = {
  "id": 309,
  "name": "electrike",
  "height": 6,
  "weight": 152,
  "base_experience": 59,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "leer",
    "bite",
    "roar",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "spark",
    "charge",
    "odor-sleuth",
    "howl",
    "shock-wave",
    "thunder-fang",
    "discharge",
    "wild-charge"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "thunder",
    "quick-attack",
    "thunder-fang",
    "wild-charge",
    "zap-cannon",
    "thunderbolt",
    "thunder-punch",
    "volt-crash",
    "electric-wrath",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 153,
    "item": null,
    "species": [
      {
        "name": "electrike",
        "order": 335,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "manectric",
        "order": 336,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 309,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 65,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
